(function() {
  var isCustomerLoggedIn = document.documentElement.hasAttribute('data-customer-logged-in');

  function showGuestMessage() {
    var existing = document.querySelector('.wishlist-guest-toast');
    if (existing) {
      existing.remove();
    }

    var toast = document.createElement('div');
    toast.className = 'wishlist-guest-toast';
    toast.textContent = 'Please log in or create an account to add items to your wishlist';
    toast.setAttribute('role', 'status');
    toast.setAttribute('aria-live', 'polite');

    document.body.appendChild(toast);

    requestAnimationFrame(function() {
      toast.classList.add('is-visible');
    });

    setTimeout(function() {
      toast.classList.remove('is-visible');
      setTimeout(function() {
        if (toast.parentNode) {
          toast.parentNode.removeChild(toast);
        }
      }, 300);
    }, 3000);
  }

  function handleWishlistClick(e) {
    if (isCustomerLoggedIn) return;

    var target = e.target;
    var wishlistBtn = target.closest('[data-frcp-product-handle], .frcp-wishlist-wrapper, button[aria-label*="wishlist" i], button[aria-label*="favourite" i]');

    if (wishlistBtn) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      showGuestMessage();
      return false;
    }
  }

  document.addEventListener('click', handleWishlistClick, true);
})();
